(ns ui.components.input.email
  (:require
   [common.email :as email]
   [common.util :as cu]
   [ui.util :as uu]
   [oops.core :as oops]
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(defn view
  [{:keys [_value _placeholder _class _on-change _disabled? _transparent? _auto-focus? _on-focus _on-blur _variant _on-valid-status-change _on-key-down]}]
  (let [state* (r/atom {})]
    (fn [{:keys [value placeholder class on-change disabled? transparent? auto-focus? on-focus on-blur variant on-valid-status-change on-key-down]}]
      (let [{:keys [selection-start selection-end]} @state*]
        [:input
         (merge {:ref         (fn [input-ref]
                                (when input-ref
                                  (when (:focused? @state*)
                                    (oops/ocall input-ref "setSelectionRange" selection-start selection-end))
                                  (when-not (:initialized? @state*)
                                    (swap! state* assoc :initialized? true)
                                    (when auto-focus?
                                      (oops/ocall input-ref "focus")))))
                 :class-name  (uu/cm "peer h-10 px-3 text-md text-input-light-text rounded"
                                     "placeholder-transparent focus:outline-none focus:ring-0"
                                     (if transparent?
                                       "bg-transparent disabled:bg-transparent"
                                       "bg-input-light disabled:bg-disabled-regular")
                                     (if (not= variant :borderless)
                                       "py-2 border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                       "py-2 border-none focus:border-transparent ")
                                     (when-not (cu/blank-value? value)
                                       "value")
                                     class)
                 :placeholder (or placeholder "")
                 :on-key-down (fn [e]
                                (when (fn? on-key-down)
                                  (on-key-down e)))
                 :value       (or (:temp-value @state*)
                                  value "")
                 :on-focus    (fn [_e]
                                (swap! state* assoc :focused? true)
                                (when (fn? on-focus)
                                  (on-focus)))
                 :on-blur     (fn [e]
                                (swap! state* assoc :temp-value nil)
                                (when (fn? on-valid-status-change)
                                  (on-valid-status-change (assoc @state*
                                                            :evt
                                                            :input.event/blur)))
                                (when (fn? on-blur)
                                  (on-blur (dg/event-target-value e))))
                 :on-change   (fn [e]
                                (let [value (dg/event-target-value e)
                                      target (dg/target e)]
                                  (swap! state* assoc
                                         :selection-start (oops/oget target "selectionStart")
                                         :selection-end (oops/oget target "selectionEnd"))
                                  (when (fn? on-valid-status-change)
                                    (swap! state* assoc :valid? (email/valid-email? value)))
                                  (cond (fn? on-change)
                                        (on-change value)
                                        :else
                                        (swap! state* assoc :temp-value value))))}
                (when disabled?
                  {:disabled true}))]))))
